import React, { useEffect, useRef } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const CONTACT_FIRST_NAME_SLUG = 'contact_first_name'

const ContactLastName: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control, getValues, trigger } = useFormContext()
  const { t } = useTranslation()

  const self = getValues(name)
  const allFields = (getValues('fields') as any[]) || []
  const contactFirstNameIndex = allFields.findIndex(
    f => f?.slug === CONTACT_FIRST_NAME_SLUG && f?.category === self?.category && f?.farmerId === self?.farmerId
  )
  const contactFirstNameValue = contactFirstNameIndex >= 0 ? `fields[${contactFirstNameIndex}].value` : undefined

  // Re-validate the paired field whenever this field's committed value changes,
  // so its required state stays in sync in both directions.
  const ownValue = useWatch({ control, name: `${name}.value` })
  const didMount = useRef(false)
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }
    if (contactFirstNameValue) trigger(contactFirstNameValue)
  }, [ownValue])

  const required = !disabled && Boolean(field.fieldRequired)

  const rules = {
    ...(required && {
      required: {
        value: true,
        message: t('Please enter Contact last name')
      }
    }),
    validate: (value: string) => {
      if (disabled || value) return true
      const siblingValue = contactFirstNameValue ? getValues(contactFirstNameValue) : undefined
      if (siblingValue) {
        return t('Please enter Contact last name')
      }
      return true
    }
  }

  return (
    <FormFields.Input
      name={`${name}.value`}
      control={control}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder}
      rules={rules}
    />
  )
}

export default ContactLastName
